import React from "react";

const Privacy = () => {
  return (
    <div className="content space-bottom">
      <h1 className="title">Datenschutzerklärung</h1>
      Verantwortliche Stelle im Sinne der Datenschutzgesetze, insbesondere der
      EU-Datenschutzgrundverordnung (DSGVO), ist:
      <p>
        Ludger Brauckhoff
        <br />
        Longericher Straße 136
        <br />
        50739 Köln-Bilderstöckchen
        <br />
        E-Mail: Ludger.Brauckhoff@netzwerk.koeln
        <br />
      </p>
      <h2 className="subtitle">Ihre Betroffenenrechte</h2>
      <p>
        Unter den angegebenen Kontaktdaten unseres Datenschutzbeauftragten
        können Sie jederzeit folgende Rechte ausüben:
      </p>
      <ul>
        <li>
          Auskunft über Ihre bei uns gespeicherten Daten und deren Verarbeitung
          (Art. 15 DSGVO)
        </li>
        <li>
          Berichtigung unrichtiger personenbezogener Daten (Art. 16 DSGVO)
        </li>
        <li>Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO)</li>
        <li>
          Einschränkung der Datenverarbeitung, sofern wir Ihre Daten aufgrund
          gesetzlicher Pflichten noch nicht löschen dürfen (Art. 18 DSGVO)
        </li>
        <li>
          Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art. 21 DSGVO)
          und
        </li>
        <li>
          Datenübertragbarkeit, sofern Sie in die Datenverarbeitung eingewilligt
          haben oder einen Vertrag mit uns abgeschlossen haben (Art. 20 DSGVO)
        </li>
      </ul>
      <p>
        Sofern Sie uns eine Einwilligung erteilt haben,können Sie diese
        jederzeit mit Wirkung für die Zukunft widerrufen. Sie können sich
        jederzeit mit einer Beschwerde an eine Aufsichtsbehörde wenden, z. B. an
        die zuständige Aufsichtsbehörde des Bundeslands Ihres Wohnsitzes oder an
        die für uns als verantwortliche Stelle zuständige Behörde. Eine Liste
        der Aufsichtsbehörden (für den nichtöffentlichen Bereich) mit Anschrift
        finden Sie unter:
        https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.
      </p>
      <h2 className="subtitle">
        Erfassung allgemeiner Informationen beim Besuch unserer Website
      </h2>
      <h3>Art und Zweck der Verarbeitung:</h3>
      <p>
        Wenn Sie auf unsere Website zugreifen, d. h., wenn Sie sich nicht
        registrieren oder anderweitig Informationen übermitteln, werden
        automatisch Informationen allgemeiner Natur erfasst. Diese Informationen
        (Server-Logfiles) beinhalten etwa die Art des Webbrowsers, das
        verwendete Betriebssystem, den Domainnamen Ihres
        Internet-Service-Providers, Ihre IP-Adresse und ähnliches. Hierbei
        handelt es sich ausschließlich um Informationen, welche keine
        Rückschlüsse auf Ihre Person zulassen.
      </p>
      <p>Sie werden insbesondere zu folgenden Zwecken verarbeitet:</p>
      <ul>
        <li>
          Sicherstellung eines problemlosen Verbindungsaufbaus der Website
        </li>
        <li>Sicherstellung einer reibungslosen Nutzung unserer Website</li>
        <li>Auswertung der Systemsicherheit und -stabilität sowie</li>
        <li>zu weiteren administrativen Zwecken</li>
      </ul>
      <p>
        Wir verwenden Ihre Daten nicht, um Rückschlüsse auf Ihre Person zu
        ziehen. Informationen dieser Art werden von uns ggfs. statistisch
        ausgewertet, um unseren Internetauftritt und die dahinterstehende
        Technik zu optimieren.
      </p>
      <h3>Rechtsgrundlage:</h3>
      <p>
        Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis
        unseres berechtigten Interesses an der Verbesserung der Stabilität und
        Funktionalität unserer Website.
      </p>
      <h3>Empfänger:</h3>
      <p>
        Empfänger der Daten sind ggf. technische Dienstleister, die für den
        Betrieb und die Wartung unserer Webseite als Auftragsverarbeiter tätig
        werden.
      </p>
      <h3>Speicherdauer:</h3>
      <p>
        Die Daten werden gelöscht, sobald diese für den Zweck der Erhebung nicht
        mehr erforderlich sind. Dies ist für die Daten, die der Bereitstellung
        der Webseite dienen, grundsätzlich der Fall, wenn die jeweilige Sitzung
        beendet ist.
      </p>
      <h3>Bereitstellung vorgeschrieben oder erforderlich:</h3>
      <p>
        Die Bereitstellung der vorgenannten personenbezogenen Daten ist weder
        gesetzlich noch vertraglich vorgeschrieben. Ohne die IP-Adresse ist
        jedoch der Dienst und die Funktionsfähigkeit unserer Website nicht
        gewährleistet. Zudem können einzelne Dienste und Services nicht
        verfügbar oder eingeschränkt sein. Aus diesem Grund ist ein Widerspruch
        ausgeschlossen.
      </p>
      <h2 className="subtitle">Verwendung von Google Analytics</h2>
      <h3>Art und Zweck der Verarbeitung:</h3>
      <p>
        Diese Website benutzt Google Analytics, einen Webanalysedienst der
        Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043 USA
        (nachfolgend: „Google“). Google Analytics verwendet sog. „Cookies“, also
        Textdateien, die auf Ihrem Computer gespeichert werden und die eine
        Analyse der Benutzung der Webseite durch dich ermöglichen. Die durch das
        Cookie erzeugten Informationen über Ihre Benutzung dieser Webseite
        werden in der Regel an einen Server von Google in den USA übertragen und
        dort gespeichert. Aufgrund der Aktivierung der IP-Anonymisierung auf
        diesen Webseiten, wird Ihre IP-Adresse von Google jedoch innerhalb von
        Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten
        des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Nur
        in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google
        in den USA übertragen und dort gekürzt. Im Auftrag des Betreibers dieser
        Website wird Google diese Informationen benutzen, um Ihre Nutzung der
        Webseite auszuwerten, um Reports über die Webseitenaktivitäten
        zusammenzustellen und um weitere mit der Websitenutzung und der
        Internetnutzung verbundene Dienstleistungen gegenüber dem
        Webseitenbetreiber zu erbringen. Die im Rahmen von Google Analytics von
        Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von
        Google zusammengeführt.
      </p>
      <p>
        Die Zwecke der Datenverarbeitung liegen in der Auswertung der Nutzung
        der Website und in der Zusammenstellung von Reports über Aktivitäten auf
        der Website. Auf Grundlage der Nutzung der Website und des Internets
        sollen dann weitere verbundene Dienstleistungen erbracht werden.
      </p>
      <h3>Rechtsgrundlage:</h3>
      <p>
        Die Verarbeitung der Daten erfolgt auf Grundlage einer Einwilligung des
        Nutzers (Art. 6 Abs. 1 lit. a DSGVO).
      </p>
      <h3>Empfänger:</h3>
      <p>
        Empfänger der Daten ist Google als Auftragsverarbeiter. Hierfür haben
        wir mit Google den entsprechenden Auftragsverarbeitungsvertrag
        abgeschlossen.
      </p>
      <h3>Speicherdauer:</h3>
      <p>
        Die Löschung der Daten erfolgt, sobald diese für unsere
        Aufzeichnungszwecke nicht mehr erforderlich sind.
      </p>
      <h3>Drittlandtransfer:</h3>
      <p>
        Google verarbeitet Ihre Daten in den USA und hat sich dem EU_US Privacy
        Shield unterworfen https://www.privacyshield.gov/EU-US-Framework.
        Außerdem haben wir Standarddatenschutzklauseln mit Google für den
        Einsatz von Google Analytics abgeschlossen.
      </p>
      <h3>Bereitstellung vorgeschrieben oder erforderlich:</h3>
      <p>
        Die Bereitstellung Ihrer personenbezogenen Daten erfolgt freiwillig,
        allein auf Basis Ihrer Einwilligung. Sofern Sie den Zugriff unterbinden,
        kann es hierdurch eventuell zu Funktionseinschränkungen auf der Website
        kommen.
      </p>
      <h3>Widerruf der Einwilligung:</h3>
      <p>
        Sie können die Speicherung der Cookies durch eine entsprechende
        Einstellung Ihrer Browser-Software verhindern; wir weisen dich jedoch
        darauf hin, dass du in diesem Fall gegebenenfalls nicht sämtliche
        Funktionen dieser Website vollumfänglich nutzen können wirst. Du kannst
        darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre
        Nutzung der Webseite bezogenen Daten (inkl. Ihrer IP-Adresse) an Google
        sowie die Verarbeitung dieser Daten durch Google verhindern, indem du
        das unter dem folgenden Link verfügbare Browser-Plugin herunterlädtst
        und installierst:{" "}
        <a href="http://tools.google.com/dlpage/gaoptout?hl=de">
          Browser Add On zur Deaktivierung von Google Analytics.
        </a>
      </p>
      <h3>Profiling:</h3>
      <p>
        Mit Hilfe des Tracking-Tools Google Analytics kann das Verhalten der
        Besucher der Webseite bewertet und die Interessen analysiert werden.
        Hierzu erstellen wir ein pseudonymes Nutzerprofil.
      </p>
      <h2 className="subtitle">SSL-Verschlüsselung</h2>
      <p>
        Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden
        wir dem aktuellen Stand der Technik entsprechende
        Verschlüsselungsverfahren (z. B. SSL) über HTTPS.
      </p>
      <h2 className="subtitle">Änderung unserer Datenschutzbestimmungen</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie
        stets den aktuellen rechtlichen Anforderungen entspricht oder um
        Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z.
        B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt
        dann die neue Datenschutzerklärung.
      </p>
      <h2 className="subtitle">Fragen an den Datenschutzbeauftragten</h2>
      <p>
        Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine
        E-Mail oder wenden Sie sich direkt an unseren Datenschutzbeauftragten,
        Kontakt s.o.
      </p>
      <em>
        Die Datenschutzerklärung wurde mit dem Datenschutzerklärungs-Generator
        der activeMind AG erstellt (Version 2018-06-22), und leicht angepasst
      </em>
    </div>
  );
};

export default Privacy;



/** WEBPACK FOOTER **
 ** ./src/components/Privacy.jsx
 **/